import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import MsgDialog from "Flow2/components/AdvancedBox/AdvancedUI/MsgDialog/MsgDialog";
import { faQ, pHelp, upQHelp } from 'Flow2/components/AdvancedBox/AdvancedConfig/SearchQuestions';
import HelpForm from 'Flow2/components/AdvancedBox/AdvancedUI/HelpForm/HelpForm';
import HelpList from 'Flow2/components/AdvancedBox/AdvancedUI/HelpList/HelpList';
import { faPlus, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './HelpDialog.scss';

const HelpDialog = (props) => {
    const [helpCur, setHelpCur] = useState(null);
    const [isOpened, setIsOpened] = useState(props.isOpened);

    const fm = ({ id }) => props.intl.formatMessage({ id });

    const onHelpForm = (el) => {
        setHelpCur(el);
    }

    const getDlgData = () => {
        if (props.isFaq) return { data: faQ, heading: 'advanced.faq' };
        return { data: pHelp, heading: 'advanced.help' }
    }

    const getUpQDlgData = () => {
        if (props.isFaq) return { data: faQ, heading: 'advanced.upQ' };
        return { data: upQHelp, heading: 'advanced.upQ' }
    }

    const showHelpDialog = () => {
        const res = getDlgData();
        return (
            <div className="helpdialog-form">
                <h1>{fm({ id: res.heading })}</h1>
                <HelpForm data={res.data} current={helpCur} required={false} error={false}
                    onDDClick={onHelpForm} setInit={() => setHelpCur(null)} />
                {helpCur && <HelpList helpCur={helpCur} data={res.data} onShowAll={() => setHelpCur(null)} />}
                {!helpCur && <HelpList data={res.data} />}
            </div>
        )
    }

    const showUpQDialog = () => {
        const res = getUpQDlgData();
        return (
            <div className="helpdialog-form">
                <h1><FontAwesomeIcon icon={faQuestion} />{fm({ id: res.heading })}</h1>
                <div className="helpdialog-form-content">
                    {res.data.map(item => (
                        <p><span className="helpdialog-label">{item.label}</span>{item.value}</p>
                    ))}
                </div>
            </div>
        )
    }

    const showSearchHelp = () => {
        const res = getDlgData();
        return (
            <div className="helpdialog-form">
                <h1><FontAwesomeIcon icon={faQuestion} />{fm({ id: res.heading })}</h1>
                <div className="helpdialog-form-content">
                    {res.data.map(item => <p>{item.value}</p>)}
                </div>
            </div>
        )
    }

    const onDlgClose = () => {
        if (props.onClose) props.onClose();
        setIsOpened(false);
    }

    useEffect(() => {
        setIsOpened(props.isOpened);
    }, [props.isOpened])

    return (
        <div className="helpdialog">
            <div className="helpdialog-box">
                <MsgDialog text={'MsgDialog'} htmlClasses={props.htmlClasses ? props.htmlClasses : 'xl-show'}
                    open={isOpened} handleMsgDialog={() => { }}>
                    {(isOpened && props.isFaq) && showHelpDialog()}
                    {(isOpened && !props.isFaq && !props.isUpQ) && showSearchHelp()}
                    {(isOpened && props.isUpQ) && showUpQDialog()}
                    <div className="advanced-close" onClick={onDlgClose}>
                        <FontAwesomeIcon icon={faPlus} />
                    </div>
                </MsgDialog>
            </div>
        </div>
    )
}

export default injectIntl(HelpDialog);